import React, { Suspense } from "react";
import { Route, BrowserRouter, Routes } from 'react-router-dom'
import 'bootstrap/dist/css/bootstrap.min.css';
import "./styles/index.scss"
import LayoutMain from "./mainLayout";
import { BrowserView, MobileView } from "react-device-detect";
import UserManagement from "./desktop/UserManagement";
import InvoiceManagement from "./desktop/InvoiceManagement";
//import InvoiceDetails from "./desktop/InvoiceManagement/ViewInvoice/invoicedetails";
import InvoiceDetails from "./desktop/invoice/[id]";
import InvoiceDetailsNew from "./desktop/invoicenew/[id]";
import PageNotFoundBrowser from "./errorPagebrowser";
import PageUnAuthorized from "./errorUnAuthorized";
import PageNotFoundMobile from "./errorPagemobile";
import ManageCustomField from "./desktop/UserManagement/customFileds";
import DownloadApp from "./home/downloadapp";
import CcaasValidation from "./home/ccaasValidation";
import UcaasValidation from "./home/ucaasValidation";
import UserValidation from "./home/userValidation";
import ProfileSettings from "./desktop/AccountManagement/ProfileSettings";
import SaveGreetings from "./desktop/AccountManagement/SaveGreetings";
import Role from "./desktop/UserManagement/Role";
import RolePermission from "./desktop/UserManagement/Role/rolespermission";
import EditRolePermission from "./desktop/UserManagement/Role/editrolespermission";
import NumberManagement from "./desktop/NumberManagement";
import EditUsers from "./desktop/UserManagement/ViewUser/editUser";
import PortIn from "./desktop/Portin";
import PortNumberScreen from "./desktop/Portin/Portnumber";
import AddUsers from "./desktop/UserManagement/ViewUser/addUser";
import AssignedNewNumbers from "./desktop/NumberManagement/AssignedNumber/addnewnumber";
import PaymentForm from "./desktop/NumberManagement/AssignedNumber/payment";
import ConfirmOrder from "./desktop/NumberManagement/AssignedNumber/confirmorder";
import PaymentMethod from "./desktop/NumberManagement/AssignedNumber/paymentmethod";
import SaveOrderConfirmation from "./desktop/NumberManagement/AssignedNumber/saveorderconfirmation";
import ThreedSForm from "./desktop/NumberManagement/AssignedNumber/3ds_form";
import ThreedSFormCheck from "./desktop/NumberManagement/AssignedNumber/3ds_form_check";
import PaymentFaild from "./desktop/NumberManagement/AssignedNumber/payment_failed";
import AddonFaild from "./desktop/AddOns/payment_failed";
import PaymentConfirm from "./desktop/NumberManagement/AssignedNumber/success";
import Congrats from "./desktop/Portin/Portnumber/congrats"
import MainAutoReceptionist from "./desktop/AccountManagement/AutoReceptionist";
import ForgotPassword from "./home/forgotPassword";
import ResetPassword from "./home/resetPassword";
import Step2 from "./step2";
import AdminOnboarding from "./desktop/AdminOnboarding";
import UserOnboarding from "./desktop/UserOnboarding";
import SecurityPolicy from "./desktop/SecurityPolicy";
import CreateSecurityPolicy from "./desktop/SecurityPolicy/createsecuritypolicy";
import Domain from "./desktop/domain";
import SubdomainEdit from "./desktop/domain/subdomainedit";
import ActivitiesLog from "./desktop/AccountManagement/AutoReceptionist/activitieslog";
import HuntGroup from "./desktop/Huntgroup";
import HuntProfile from "./desktop/Huntgroup/huntprofile";
import NewhuntGroup from "./desktop/Huntgroup/Newhuntgroup";
import Edithuntgroup from "./desktop/Huntgroup/Edithuntgroup";
import PurchaseFlows from "./desktop/AddOns";
import CartItemsLists from "./desktop/AddOns/cartitem";
import PayMentConfirm from "./desktop/AddOns/paymentConfirm"; //2
import Paymentmethods from "./desktop/SubscriptionAndBilling/Payment";
import AddCard from "./desktop/SubscriptionAndBilling/Payment/addCard";
import Subscription_Billing from "./desktop/SubscriptionBilling";
import BillingContacts from "./desktop/SubscriptionBilling/billingContacts";
import UpgardeDetails from "./desktop/Upgrade/upgradeDetails";
import EditCard from "./desktop/SubscriptionAndBilling/Payment/editCard";
import PaymentCardList from "./desktop/SubscriptionAndBilling/Payment/paymentCardList";
import UpgradeSuccess from "./desktop/Upgrade/success";
import DashbordUpgrade from "./desktop/Upgrade/upgradedashboard";
import LayoutMainFull from "./mainLayout/fullmode";
import AccountInfo from "./desktop/AccountManagement/AccountInfo";
import EditAccountInfo from "./desktop/AccountManagement/AccountInfo/edit";
import DeviceManagementMain from "./desktop/DeviceManagement";
import GroupDetails from "./desktop/Huntgroup/Newhuntgroup/groupdetails";
import UpgradeSuccessPlan from "./desktop/Upgrade/successupgradeplan";
import CallQueue from "./desktop/CallQueue";
import CallQueueProfile from "./desktop/CallQueue/callqueueprofile";
import AddCallQueue from "./desktop/CallQueue/Addcallqueue";
import AccountVoicemail from "./desktop/AccountManagement/AutoReceptionist/voiceMail";
import ProfileDetails from "./desktop/ProfileSetting";
import ProfileDetailsEdit from "./desktop/ProfileSetting/edit";
import UpgradeMain from "./desktop/Upgrade";
import EditCallQueue from "./desktop/CallQueue/Editcallqueue";
import ViewDevice from "./desktop/DeviceManagement/viewDevice";
import PurchaseDevice from "./desktop/DeviceManagement/purchaseDevice";
import PurchaseAddress from "./desktop/DeviceManagement/purchaseAddress";
import PurchaseConfirmation from "./desktop/DeviceManagement/confirmationSection";
import UpgradeSuccessDevice from "./desktop/DeviceManagement/successdevice";
import Reassign from "./desktop/DeviceManagement/AssignedDevices/ressign";
import ReassignDevice from "./desktop/DeviceManagement/AssignedDevices/reassigndevice";
import ReplaceDevice from "./desktop/DeviceManagement/AssignedDevices/replacedevice";
import PurchasePhone from "./desktop/DeviceManagement/AssignedDevices/purchasephone";
import BringYourownPhone from "./desktop/DeviceManagement/AssignedDevices/bringyourownphone";
import MobileOnboarding from "./desktop/AdminOnboarding/mobile";
import SwapPhone from "./desktop/DeviceManagement/AssignedDevices/swapphone";
import ReportsMain from "./desktop/Reports";
import WorktualReports from "./desktop/WorktualReports";
import ViewReports from "./desktop/WorktualReports/viewReports";
import SetupDevices from "./desktop/DeviceManagement/purchaseDeviceTab/setDevice";
import DevicePaymentFailed from "./desktop/DeviceManagement/paymentfailed";
import CcassPlanUpgrade from "./desktop/Upgrade/ccassplanpage";
import CcassPlanDetails from "./desktop/Upgrade/ccassplandetails";
import MDashboardPage from "./mobile/Dashboard"
import LayoutMainMobile from "./mainLayout/mobilelayout";
import PaymentUpgradeFailed from "./desktop/Upgrade/payment_failed";
import InitialChecks from "./desktop/Portin/Portnumber/initialchecks";
import Basicinfo from "./desktop/Portin/Portnumber/basicinfo";
import SelectNumbers from "./desktop/Portin/Portnumber/selectnumber";
import NumberMapping from "./desktop/Portin/Portnumber/numbermaping";
import LetterAuthorization from "./desktop/Portin/Portnumber/letterauthorization";
import ProfileDetailsMobile from "./mobile/MyProfile";
import ProfileDetailsEditMobile from "./mobile/MyProfile/edit";
import ActivitiesLogMobile from "./mobile/ActivityLog";
import WithPassword from "./desktop/AdminOnboarding/withPassword";
import OverviewPage from "./desktop/Dashboard/overview";
import DashboardPage from "./desktop/Dashboard/dashboardindex";
import UcassPlanDetails from "./desktop/Upgrade/ucassplandetails";
import UcassPlanUpgrade from "./desktop/Upgrade/ucassdashboard";
import IVREdits from "./desktop/AccountManagement/AutoReceptionist/ivredit";
import OverviewPageMobile from "./mobile/Overview";
import UserManagementMobile from "./mobile/Users";
import UserImportMapping from "./desktop/UserManagement/ViewUser/importUser";
import NewUpgardeDetails from "./desktop/NewPlanUpgrade/upgradedashboard";
import UpgardeDetails1 from "./desktop/NewPlanUpgrade/upgradeDetails";
import Upgrade_License from "./desktop/UserManagement/ViewUser/upgradelicense";
import UpgradeDid_License from "./desktop/UserManagement/ViewUser/upgradelicensedid";
import LicenseSuccess from "./desktop/UserManagement/ViewUser/success";
import AddUsersMobile from "./mobile/Users/ViewUser/addUsermobile";
import EditUsersMobile from "./desktop/UserManagement/ViewUser/editUser";
import ViewUsersMobile from "./desktop/UserManagement/ViewUser/viewUser";
import PaymentCommonFailed from "./step2/payment_failed";
import AddonSuccess from "./desktop/AddOns/success";
import AccountInfoMobile from "./mobile/AccountInfo";
import NumberManagementMobile from "./mobile/NumberManagement";
import AssignedNewNumbersMobile from "./mobile/NumberManagement/AssignedNumber/addnewnumber";
import PaymentMethodMobile from "./mobile/NumberManagement/AssignedNumber/paymentmethod";
import ConfirmOrderMobile from "./mobile/NumberManagement/AssignedNumber/confirmorder";
import PaymentFormMobile from "./mobile/NumberManagement/AssignedNumber/payment";
import SaveOrderConfirmationMobile from "./mobile/NumberManagement/AssignedNumber/saveorderconfirmation";
import PaymentFaildMobile from "./mobile/NumberManagement/AssignedNumber/payment_failed";
import ThreeDsFormMobile from "./mobile/NumberManagement/AssignedNumber/3ds_form";
import PaymentConfirmMobile from "./mobile/NumberManagement/AssignedNumber/paymentconfirmation";
import ThreedSFormCheckMobile from "./mobile/NumberManagement/AssignedNumber/3ds_form_check";
import RoleMobile from "./mobile/Users/Role";
import TopupFailed from "./desktop/SubscriptionAndBilling/Payment/payment_failed";
import TopupSuccess from "./desktop/SubscriptionAndBilling/Payment/Payment_success";
import PaymentmethodsMobile from "./mobile/SubscriptionAndBilling/Payment";
import AddCardMobile from "./mobile/SubscriptionAndBilling/Payment/addCard";
import EditCardMobile from "./mobile/SubscriptionAndBilling/Payment/editCard";
import PaymentCardListMobile from "./mobile/SubscriptionAndBilling/Payment/paymentCardList";
import UpgardeDetailsMobile from "./mobile/SubscriptionAndBilling/Upgrade/upgradeDetails";
import UpgradeSuccessMobile from "./mobile/SubscriptionAndBilling/Upgrade/success";
import UcassPlanDetailsMobile from "./mobile/SubscriptionAndBilling/Upgrade/ucassplandetails";
import DashbordUpgradeMobile from "./mobile/SubscriptionAndBilling/Upgrade/upgradedashboard";
import CcassPlanUpgradeMobile from "./mobile/SubscriptionAndBilling/Upgrade/ccassplanpage";
import UcassPlanUpgradeMobile from "./mobile/SubscriptionAndBilling/Upgrade/ucassdashboard";
import CcassPlanDetailsMobile from "./mobile/SubscriptionAndBilling/Upgrade/ccassplandetails";
import UpgradeMainMobile from "./mobile/SubscriptionAndBilling/Upgrade/Upgrade";
import BillingContactsMobile from "./mobile/SubscriptionAndBilling/billingContacts";
import NewUpgardeDetailsMobile from "./mobile/SubscriptionAndBilling/NewPlanUpgrade/upgradedashboard";
import UpgardeDetails1Mobile from "./mobile/SubscriptionAndBilling/NewPlanUpgrade/upgradeDetails";
import TopupSuccessMobile from "./mobile/SubscriptionAndBilling/Payment/Payment_success";
import TopupFailedMobile from "./mobile/SubscriptionAndBilling/Payment/payment_failed";
import AddOnsFailedMobile from "./mobile/SubscriptionAndBilling/AddOns/payment_failed";
import AddOnSuccessMobile from "./mobile/SubscriptionAndBilling/AddOns/Payment_success";
import AddOnFlowsMobile from "./mobile/SubscriptionAndBilling/AddOns";
import PayMentConfirmMobile from "./mobile/SubscriptionAndBilling/AddOns/paymentConfirm";
import InvoiceManagementMobile from "./mobile/SubscriptionAndBilling/Invoice";
import DeviceManagementMainMobile from "./mobile/DeviceManagement";
import ViewDeviceMobile from "./mobile/DeviceManagement/viewDevice";
import UpgradeSuccessDeviceMobile from "./mobile/DeviceManagement/successdevice";
import PurchaseConfirmationMobile from "./mobile/DeviceManagement/confirmationSection";
import PurchaseDeviceMobile from "./mobile/DeviceManagement/purchaseDevice";
import PurchaseAddressMobile from "./mobile/DeviceManagement/purchaseAddress";
import SetupDevicesMobile from "./mobile/DeviceManagement/purchaseDeviceTab/setDevice";
import DevicePaymentFailedMobile from "./mobile/DeviceManagement/paymentfailed";
import ReassignMobile from "./mobile/DeviceManagement/AssignedDevices/ressign";
import ReassignDeviceMobile from "./mobile/DeviceManagement/AssignedDevices/reassigndevice";
import ReplaceDeviceMobile from "./mobile/DeviceManagement/AssignedDevices/replacedevice";
import PurchasePhoneMobile from "./mobile/DeviceManagement/AssignedDevices/purchasephone";
import BringYourownPhoneMobile from "./mobile/DeviceManagement/AssignedDevices/bringyourownphone";
import SwapPhoneMobile from "./mobile/DeviceManagement/AssignedDevices/swapphone";
import MainAutoReceptionistMobile from "./mobile/AccountManagement/AutoReceptionist";
import IVREditsMobile from "./mobile/AccountManagement/AutoReceptionist/ivredit";
import ProfileSettingsMobile from "./mobile/AccountManagement/ProfileSettings";
import SaveGreetingsMobile from "./mobile/AccountManagement/SaveGreetings";
import LinkedAccount from "./desktop/LinkedAccounts/insidepage";
import HuntGroupMobile from "./mobile/AccountManagement/Huntgroup";
import NewhuntGroupMobile from "./mobile/AccountManagement/Huntgroup/Newhuntgroup";
import EditHuntGroupMobile from "./mobile/AccountManagement/Huntgroup/Edithuntgroup";
import ProductRoleTable from "./desktop/UserManagement/Role/productrole";
import ProductRoleTableMobile from "./mobile/Users/Role/productrole";
import DocumentForm from "./desktop/NumberManagement/AssignedNumber/documentForm";
import ConferenceBridge from "./desktop/conferenceBridge";
import ConferenceBridgeEdit from "./desktop/conferenceBridge/editBridge";
import VerifyEmail from "./home/otp";
import SecurityForUser from "./desktop/UserSecurity/security";
import UserGeneralSettings from "./desktop/AccountManagement/ProfileSettings/usergeneralSettings";
import UserAccountVoicemail from "./desktop/AccountManagement/ProfileSettings/uservoiceMail";
import NumberInUserPage from "./desktop/UserNumberAndDevice/numbers";
import DeviceInUserPage from "./desktop/UserNumberAndDevice/devices";
import ConferenceInUserPage from "./desktop/UserNumberAndDevice/conference";
import MainForNumberAndDevices from "./desktop/UserNumberAndDevice";
import UserGeneralSettingsMobile from "./mobile/AccountManagement/ProfileSettings/usergeneralSettings";
import MainForNumberAndDevicesMobile from "./mobile/UserNumberAndDevice";
import ConferenceInUserPageMobile from "./mobile/UserNumberAndDevice/conference";
import DeviceInUserPageMobile from "./mobile/UserNumberAndDevice/devices";
import NumberInUserPageMobile from "./mobile/UserNumberAndDevice/numbers";
import LinkedAccountMobile from "./mobile/LinkedAccounts/insidepage";
import UserAccountVoicemailMobile from "./mobile/AccountManagement/ProfileSettings/uservoiceMail";
import ReportsMainMobile from "./mobile/Reports";
import Recording from "./desktop/AccountManagement/Recording";
import SocialMediaIntegration from "./desktop/SocialMediaIntegration";
import WhatsappIntegration from "./desktop/SocialMediaIntegration/whatsapp";
import ChatBotUpgradePage from "./desktop/Upgrade/chatboatupgradepage";
import ChatBotPlanDetails from "./desktop/Upgrade/chatbotplandetails";
import XaiaTwoFree from "./desktop/Upgrade/xaiatwofree";
import SipTrunck from "./desktop/siptrunk";
import SipTrunkInfo from "./desktop/siptrunk/sipnumber/turnkinfo";
import SipTrunkInfoView from "./desktop/siptrunk/sipnumber/viewtrunkinfo";
import SipDidNumber from "./desktop/siptrunk/sipnumber/didnumber";
import SipRules from "./desktop/siptrunk/sipnumber/siprules";
import SipDidNumberView from "./desktop/siptrunk/sipnumber/viewdidnumber";
import SipRulesView from "./desktop/siptrunk/sipnumber/viewrules";
import PurchaseFlowsMain from "./desktop/AddOns/Purchasemain";
import XaiaTwoSuccessPage from "./desktop/Upgrade/xaiatwosuccess";
import PurchaseNumberAddon from "./desktop/AddOns/purchasenumber";
import AddNewNumber from "./desktop/AddOns/addnewno";
import Parklocation from "./desktop/parklocation";
import EditParkLocation from "./desktop/parklocation/edit_park_location";
import AssetLink from "./desktop/assetlinks";
import OnboardVerifyEmail from "./desktop/AdminOnboarding/emailVerify";
import ShopifyPlanUpgradeSuccess from "./desktop/Upgrade/shopifySuccess";
import NewProductCcaasUpgardeDetails from "./desktop/Upgrade/product_ccaas";
import NewProductUcaasUpgardeDetails from "./desktop/Upgrade/product_uccas";
import NewProductChatbotUpgardeDetails from "./desktop/Upgrade/product_chatbot";
import CrmPlanDetails from "./desktop/Upgrade/crmplandetails";
import Loader from "./desktop/loader";
import Serviceteams from "./newpages/teamsintegration/serviceteams";
import UserList from "./newpages/teamsintegration/userlist";
import UserSetting from "./desktop/UserManagement/ViewUser/usersetting";
import AudraCareOnboarding from "./desktop/AudraCareOnboarding";
import Servicespbx from "./newpages/teamsintegration/servicespbx";
import Initialsetup from "./newpages/teamsintegration/initialsetup";
import Accounts from "./newpages/teamsintegration/accounts";
import WorktualCallLogs from "./desktop/WorktualCallSetting/worktualcallog";
import SubOwnerValidation from "./home/subOwnerValidation";


const Home = React.lazy(() => import('./home'));
const ForgotPasswordLazy = React.lazy(() => import('./home/forgotPassword'));
const ResetPasswordLazy = React.lazy(() => import('./home/resetPassword'));
const PageNotFoundBrowserLazy = React.lazy(() => import('./errorPagebrowser'));
const PageUnAuthorizedLazy = React.lazy(() => import('./errorUnAuthorized'));
const WithPasswordLazy = React.lazy(() => import('./desktop/AdminOnboarding/withPassword'));
const AdminOnboardingLazy = React.lazy(() => import('./desktop/AdminOnboarding'));
const AudraCareOnboardingLazy = React.lazy(() => import('./desktop/AudraCareOnboarding'))
const AssetLinkLazy = React.lazy(() => import('./desktop/assetlinks'));
const MobileOnboardingLazy = React.lazy(() => import('./desktop/AdminOnboarding/mobile'));
const UserOnboardingLazy = React.lazy(() => import('./desktop/UserOnboarding'));
const OnboardVerifyEmailLazy = React.lazy(() => import('./desktop/AdminOnboarding/emailVerify'));
const DownloadAppLazy = React.lazy(() => import('./home/downloadapp'));

const PaymentCommonFailedLazy = React.lazy(() => import('./step2/payment_failed'));
const LayoutMainLazy = React.lazy(() => import('./mainLayout'));
const DashboardPageLazy = React.lazy(() => import('./desktop/Dashboard/dashboardindex'));
const OverviewPageLazy = React.lazy(() => import('./desktop/Dashboard/overview'));
const AccountInfoLazy = React.lazy(() => import('./desktop/AccountManagement/AccountInfo'));
const EditAccountInfoLazy = React.lazy(() => import('./desktop/AccountManagement/AccountInfo/edit'));
const MainAutoReceptionistLazy = React.lazy(() => import('./desktop/AccountManagement/AutoReceptionist'));
const IVREditsLazy = React.lazy(() => import('./desktop/AccountManagement/AutoReceptionist/ivredit'));
const HuntGroupLazy = React.lazy(() => import('./desktop/Huntgroup'));
const NewhuntGroupLazy = React.lazy(() => import('./desktop/Huntgroup/Newhuntgroup'));
const EdithuntgroupLazy = React.lazy(() => import('./desktop/Huntgroup/Edithuntgroup'));
const ParkLocationLazy = React.lazy(() => import('./desktop/parklocation'));
const EditParkLocationLazy = React.lazy(() => import('./desktop/parklocation/edit_park_location'));
const ProfileSettingsLazy = React.lazy(() => import('./desktop/AccountManagement/ProfileSettings'));
const SaveGreetingsLazy = React.lazy(() => import('./desktop/AccountManagement/SaveGreetings'));
const ActivitiesLogLazy = React.lazy(() => import('./desktop/AccountManagement/AutoReceptionist/activitieslog'));
const UserGeneralSettingsLazy = React.lazy(() => import('./desktop/AccountManagement/ProfileSettings/usergeneralSettings'));
const UserAccountVoicemailLazy = React.lazy(() => import('./desktop/AccountManagement/ProfileSettings/uservoiceMail'));
const NumberInUserPageLazy = React.lazy(() => import('./desktop/UserNumberAndDevice/numbers'));
const DeviceInUserPageLazy = React.lazy(() => import('./desktop/UserNumberAndDevice/devices'));
const ConferenceInUserPageLazy = React.lazy(() => import('./desktop/UserNumberAndDevice/conference'));
const MainForNumberAndDevicesLazy = React.lazy(() => import('./desktop/UserNumberAndDevice'));
const RecordingLazy = React.lazy(() => import('./desktop/AccountManagement/Recording'));
const UserManagementLazy = React.lazy(() => import('./desktop/UserManagement'));
const AddUsersLazy = React.lazy(() => import('./desktop/UserManagement/ViewUser/addUser'));
const EditUsersLazy = React.lazy(() => import('./desktop/UserManagement/ViewUser/editUser'));
const UserImportMappingLazy = React.lazy(() => import('./desktop/UserManagement/ViewUser/importUser'));
const UpgradeSuccessPlanLazy = React.lazy(() => import('./desktop/Upgrade/successupgradeplan'));
const PaymentUpgradeFailedLazy = React.lazy(() => import('./desktop/Upgrade/payment_failed'));
const Upgrade_LicenseLazy = React.lazy(() => import('./desktop/UserManagement/ViewUser/upgradelicense'));
const UpgradeDid_LicenseLazy = React.lazy(() => import('./desktop/UserManagement/ViewUser/upgradelicensedid'));
const LicenseSuccessLazy = React.lazy(() => import('./desktop/UserManagement/ViewUser/success'));
const ProductRoleTableLazy = React.lazy(() => import('./desktop/UserManagement/Role/productrole'));
const RolePermissionLazy = React.lazy(() => import('./desktop/UserManagement/Role/rolespermission'));
const EditRolePermissionLazy = React.lazy(() => import('./desktop/UserManagement/Role/editrolespermission'));
const ManageCustomFieldLazy = React.lazy(() => import('./desktop/UserManagement/customFileds'));
const NumberManagementLazy = React.lazy(() => import('./desktop/NumberManagement'));
const AssignedNewNumbersLazy = React.lazy(() => import('./desktop/NumberManagement/AssignedNumber/addnewnumber'));
const ConfirmOrderLazy = React.lazy(() => import('./desktop/NumberManagement/AssignedNumber/confirmorder'));
const PaymentMethodLazy = React.lazy(() => import('./desktop/NumberManagement/AssignedNumber/paymentmethod'));
const PaymentFormLazy = React.lazy(() => import('./desktop/NumberManagement/AssignedNumber/payment'));
const ThreedSFormLazy = React.lazy(() => import('./desktop/NumberManagement/AssignedNumber/3ds_form'));
const ThreedSFormCheckLazy = React.lazy(() => import('./desktop/NumberManagement/AssignedNumber/3ds_form_check'));
const SaveOrderConfirmationLazy = React.lazy(() => import('./desktop/NumberManagement/AssignedNumber/saveorderconfirmation'));
const PaymentFaildLazy = React.lazy(() => import('./desktop/NumberManagement/AssignedNumber/payment_failed'));
const DocumentFormLazy = React.lazy(() => import('./desktop/NumberManagement/AssignedNumber/documentForm'));
const PayMentConfirmLazy = React.lazy(() => import('./desktop/AddOns/paymentConfirm'));
const PortInLazy = React.lazy(() => import('./desktop/Portin'));
const PortNumberScreenLazy = React.lazy(() => import('./desktop/Portin/Portnumber'));
const CongratsLazy = React.lazy(() => import('./desktop/Portin/Portnumber/congrats'));
const InitialChecksLazy = React.lazy(() => import('./desktop/Portin/Portnumber/initialchecks'));
const BasicinfoLazy = React.lazy(() => import('./desktop/Portin/Portnumber/basicinfo'));
const SelectNumbersLazy = React.lazy(() => import('./desktop/Portin/Portnumber/selectnumber'));
const NumberMappingLazy = React.lazy(() => import('./desktop/Portin/Portnumber/numbermaping'));
const LetterAuthorizationLazy = React.lazy(() => import('./desktop/Portin/Portnumber/letterauthorization'));
const LayoutMainFullLazy = React.lazy(() => import('./mainLayout/fullmode'));
const SipTrunckLazy = React.lazy(() => import('./desktop/siptrunk'));
const SipTrunkInfoLazy = React.lazy(() => import('./desktop/siptrunk/sipnumber/turnkinfo'));
const SipTrunkInfoViewLazy = React.lazy(() => import('./desktop/siptrunk/sipnumber/viewtrunkinfo'));
const SipDidNumberLazy = React.lazy(() => import('./desktop/siptrunk/sipnumber/didnumber'));
const SipRulesLazy = React.lazy(() => import('./desktop/siptrunk/sipnumber/siprules'));
const SipDidNumberViewLazy = React.lazy(() => import('./desktop/siptrunk/sipnumber/viewdidnumber'));
const SipRulesViewLazy = React.lazy(() => import('./desktop/siptrunk/sipnumber/viewrules'));
const ConferenceBridgeLazy = React.lazy(() => import('./desktop/conferenceBridge'));
const ConferenceBridgeEditLazy = React.lazy(() => import('./desktop/conferenceBridge/editBridge'));
const LinkedAccountLazy = React.lazy(() => import('./desktop/LinkedAccounts/insidepage'));
const SecurityForUserLazy = React.lazy(() => import('./desktop/UserSecurity/security'));
const DeviceManagementMainLazy = React.lazy(() => import('./desktop/DeviceManagement'));
const ViewDeviceLazy = React.lazy(() => import('./desktop/DeviceManagement/viewDevice'));
const UpgradeSuccessDeviceLazy = React.lazy(() => import('./desktop/DeviceManagement/successdevice'));
const PurchaseConfirmationLazy = React.lazy(() => import('./desktop/DeviceManagement/confirmationSection'));
const PurchaseDeviceLazy = React.lazy(() => import('./desktop/DeviceManagement/purchaseDevice'));
const PurchaseAddressLazy = React.lazy(() => import('./desktop/DeviceManagement/purchaseAddress'));
const SetupDevicesLazy = React.lazy(() => import('./desktop/DeviceManagement/purchaseDeviceTab/setDevice'));
const DevicePaymentFailedLazy = React.lazy(() => import('./desktop/DeviceManagement/paymentfailed'));
const ReassignLazy = React.lazy(() => import('./desktop/DeviceManagement/AssignedDevices/ressign'));
const ReassignDeviceLazy = React.lazy(() => import('./desktop/DeviceManagement/AssignedDevices/reassigndevice'));
const ReplaceDeviceLazy = React.lazy(() => import('./desktop/DeviceManagement/AssignedDevices/replacedevice'));
const PurchasePhoneLazy = React.lazy(() => import('./desktop/DeviceManagement/AssignedDevices/purchasephone'));
const BringYourownPhoneLazy = React.lazy(() => import('./desktop/DeviceManagement/AssignedDevices/bringyourownphone'));
const SwapPhoneLazy = React.lazy(() => import('./desktop/DeviceManagement/AssignedDevices/swapphone'));
const Subscription_BillingLazy = React.lazy(() => import('./desktop/SubscriptionBilling'));
const BillingContactsLazy = React.lazy(() => import('./desktop/SubscriptionBilling/billingContacts'));
const PaymentmethodsLazy = React.lazy(() => import('./desktop/SubscriptionAndBilling/Payment'));
const AddCardLazy = React.lazy(() => import('./desktop/SubscriptionAndBilling/Payment/addCard'));
const EditCardLazy = React.lazy(() => import('./desktop/SubscriptionAndBilling/Payment/editCard'));
const PaymentCardListLazy = React.lazy(() => import('./desktop/SubscriptionAndBilling/Payment/paymentCardList'));
const UpgardeDetailsLazy = React.lazy(() => import('./desktop/Upgrade/upgradeDetails'));
const UpgradeSuccessLazy = React.lazy(() => import('./desktop/Upgrade/success'));
const UcassPlanDetailsLazy = React.lazy(() => import('./desktop/Upgrade/ucassplandetails'));
const DashbordUpgradeLazy = React.lazy(() => import('./desktop/Upgrade/upgradedashboard'));
const CcassPlanUpgradeLazy = React.lazy(() => import('./desktop/Upgrade/ccassplanpage'));
const ChatBotUpgradePageLazy = React.lazy(() => import('./desktop/Upgrade/chatboatupgradepage'));
const UcassPlanUpgradeLazy = React.lazy(() => import('./desktop/Upgrade/ucassdashboard'));
const CcassPlanDetailsLazy = React.lazy(() => import('./desktop/Upgrade/ccassplandetails'));
const ChatBotPlanDetailsLazy = React.lazy(() => import('./desktop/Upgrade/chatbotplandetails'));
const XaiaTwoFreeLazy = React.lazy(() => import('./desktop/Upgrade/xaiatwofree'));
const XaiaTwoSuccessPageLazy = React.lazy(() => import('./desktop/Upgrade/xaiatwosuccess'));
const UpgradeMainLazy = React.lazy(() => import('./desktop/Upgrade'));
const NewUpgardeDetailsLazy = React.lazy(() => import('./desktop/NewPlanUpgrade/upgradedashboard'));
const UpgardeDetails1Lazy = React.lazy(() => import('./desktop/NewPlanUpgrade/upgradeDetails'));
const NewProductCcaasUpgardeDetailsLazy = React.lazy(() => import('./desktop/Upgrade/product_ccaas'));
const NewProductUcaasUpgardeDetailsLazy = React.lazy(() => import('./desktop/Upgrade/product_uccas'));
const NewProductChatbotUpgardeDetailsLazy = React.lazy(() => import('./desktop/Upgrade/product_chatbot'));
const CrmPlanDetailsLazy = React.lazy(() => import('./desktop/Upgrade/crmplandetails'));
const TopupSuccessLazy = React.lazy(() => import('./desktop/SubscriptionAndBilling/Payment/Payment_success'));
const TopupFailedLazy = React.lazy(() => import('./desktop/SubscriptionAndBilling/Payment/payment_failed'));
const PurchaseFlowsMainLazy = React.lazy(() => import('./desktop/AddOns/Purchasemain'));
const PurchaseFlowsLazy = React.lazy(() => import('./desktop/AddOns'));
const AddonSuccessLazy = React.lazy(() => import('./desktop/AddOns/success'));
const AddonFaildLazy = React.lazy(() => import('./desktop/AddOns/payment_failed'));
const InvoiceManagementLazy = React.lazy(() => import('./desktop/InvoiceManagement'));
const InvoiceDetailsLazy = React.lazy(() => import('./desktop/invoice/[id]'));
const InvoiceDetailsNewLazy = React.lazy(() => import('./desktop/invoicenew/[id]'));
const SecurityPolicyLazy = React.lazy(() => import('./desktop/SecurityPolicy'));
const CreateSecurityPolicyLazy = React.lazy(() => import('./desktop/SecurityPolicy/createsecuritypolicy'));
const DomainLazy = React.lazy(() => import('./desktop/domain'));
const SubdomainEditLazy = React.lazy(() => import('./desktop/domain/subdomainedit'));
const SocialMediaIntegrationLazy = React.lazy(() => import('./desktop/SocialMediaIntegration'));
const WhatsappIntegrationLazy = React.lazy(() => import('./desktop/SocialMediaIntegration/whatsapp'));
const ProfileDetailsLazy = React.lazy(() => import('./desktop/ProfileSetting'));
const ProfileDetailsEditLazy = React.lazy(() => import('./desktop/ProfileSetting/edit'));
const CartItemsListsLazy = React.lazy(() => import('./desktop/AddOns/cartitem'));
const PaymentConfirmLazy = React.lazy(() => import('./desktop/NumberManagement/AssignedNumber/success'));
const Step2Lazy = React.lazy(() => import('./step2'));
const PurchaseNumberAddonLazy = React.lazy(() => import('./desktop/AddOns/purchasenumber'));
const AddNewNumberLazy = React.lazy(() => import('./desktop/AddOns/addnewno'));
const ReportsMainLazy = React.lazy(() => import('./desktop/Reports'));
const ShopifyPlanUpgradeSuccessLazy = React.lazy(() => import('./desktop/Upgrade/shopifySuccess'));
const HuntProfileLazy = React.lazy(() => import('./desktop/Huntgroup/huntprofile'));
const CallQueueLazy = React.lazy(() => import('./desktop/CallQueue'));
const CallQueueProfileLazy = React.lazy(() => import('./desktop/CallQueue/callqueueprofile'));
const AddCallQueueLazy = React.lazy(() => import('./desktop/CallQueue/Addcallqueue'));
const EditCallQueueLazy = React.lazy(() => import('./desktop/CallQueue/Editcallqueue'));
const WorktualReportsLazy = React.lazy(() => import('./desktop/WorktualReports'));
const ViewReportsLazy = React.lazy(() => import('./desktop/WorktualReports/viewReports'));
const VerifyEmailLazy = React.lazy(() => import('./home/otp'));
const PageNotFoundMobileLazy = React.lazy(() => import('./errorPagemobile'));
const UserCallLog = React.lazy(() => import('./desktop/AccountManagement/ProfileSettings/usercalllogs'));
const AdminCallLog = React.lazy(() => import('./desktop/AccountManagement/AdminCallSetting/calllog'));
const WorktualCallLog = React.lazy(() => import('./desktop/WorktualCallSetting/calllog'));
const CallLogin = React.lazy(() => import('./desktop/WorktualCallSetting'));
const ShopifydowngradePage = React.lazy(() => import('./desktop/Upgrade/shopifydowngradeplan'));
const ShopifyPlanDetails = React.lazy(() => import('./desktop/Upgrade/shopifyplandetails'));
const AddOnUser = React.lazy(() => import('./desktop/AddOns/addonUser'));
const AddCustomNumber = React.lazy(() => import('./desktop/NumberManagement/AssignedNumber/addnumber'));


const LayoutMainMobileLazy = React.lazy(() => import('./mainLayout/mobilelayout'));
const MDashboardPageLazy = React.lazy(() => import('./mobile/Dashboard'));
const OverviewPageMobileLazy = React.lazy(() => import('./mobile/Overview'));
const UserManagementMobileLazy = React.lazy(() => import('./mobile/Users'));
const AddUsersMobileLazy = React.lazy(() => import('./mobile/Users/ViewUser/addUsermobile'));
const EditUsersMobileLazy = React.lazy(() => import('./desktop/UserManagement/ViewUser/editUser'));
const ViewUsersMobileLazy = React.lazy(() => import('./desktop/UserManagement/ViewUser/viewUser'));
const ProductRoleTableMobileLazy = React.lazy(() => import('./mobile/Users/Role/productrole'));
const ProfileDetailsMobileLazy = React.lazy(() => import('./mobile/MyProfile'));
const ProfileDetailsEditMobileLazy = React.lazy(() => import('./mobile/MyProfile/edit'));
const AccountInfoMobileLazy = React.lazy(() => import('./mobile/AccountInfo'));
const ActivitiesLogMobileLazy = React.lazy(() => import('./mobile/ActivityLog'));
const NumberManagementMobileLazy = React.lazy(() => import('./mobile/NumberManagement'));
const AssignedNewNumbersMobileLazy = React.lazy(() => import('./mobile/NumberManagement/AssignedNumber/addnewnumber'));
const ConfirmOrderMobileLazy = React.lazy(() => import('./mobile/NumberManagement/AssignedNumber/confirmorder'));
const PaymentMethodMobileLazy = React.lazy(() => import('./mobile/NumberManagement/AssignedNumber/paymentmethod'));
const PaymentFormMobileLazy = React.lazy(() => import('./mobile/NumberManagement/AssignedNumber/payment'));
const ThreeDsFormMobileLazy = React.lazy(() => import('./mobile/NumberManagement/AssignedNumber/3ds_form'));
const ThreedSFormCheckMobileLazy = React.lazy(() => import('./mobile/NumberManagement/AssignedNumber/3ds_form_check'));
const SaveOrderConfirmationMobileLazy = React.lazy(() => import('./mobile/NumberManagement/AssignedNumber/saveorderconfirmation'));
const PaymentFaildMobileLazy = React.lazy(() => import('./mobile/NumberManagement/AssignedNumber/payment_failed'));
const PaymentConfirmMobileLazy = React.lazy(() => import('./mobile/NumberManagement/AssignedNumber/paymentconfirmation'));
const BillingContactsMobileLazy = React.lazy(() => import('./mobile/SubscriptionAndBilling/billingContacts'));
const PaymentmethodsMobileLazy = React.lazy(() => import('./mobile/SubscriptionAndBilling/Payment'));
const AddCardMobileLazy = React.lazy(() => import('./mobile/SubscriptionAndBilling/Payment/addCard'));
const EditCardMobileLazy = React.lazy(() => import('./mobile/SubscriptionAndBilling/Payment/editCard'));
const PaymentCardListMobileLazy = React.lazy(() => import('./mobile/SubscriptionAndBilling/Payment/paymentCardList'));
const UpgardeDetailsMobileLazy = React.lazy(() => import('./mobile/SubscriptionAndBilling/Upgrade/upgradeDetails'));
const UcassPlanDetailsMobileLazy = React.lazy(() => import('./mobile/SubscriptionAndBilling/Upgrade/ucassplandetails'));
const DashbordUpgradeMobileLazy = React.lazy(() => import('./mobile/SubscriptionAndBilling/Upgrade/upgradedashboard'));
const CcassPlanUpgradeMobileLazy = React.lazy(() => import('./mobile/SubscriptionAndBilling/Upgrade/ccassplanpage'));
const UcassPlanUpgradeMobileLazy = React.lazy(() => import('./mobile/SubscriptionAndBilling/Upgrade/ucassdashboard'));
const CcassPlanDetailsMobileLazy = React.lazy(() => import('./mobile/SubscriptionAndBilling/Upgrade/ccassplandetails'));
const UpgradeMainMobileLazy = React.lazy(() => import('./mobile/SubscriptionAndBilling/Upgrade/Upgrade'));
const NewUpgardeDetailsMobileLazy = React.lazy(() => import('./mobile/SubscriptionAndBilling/NewPlanUpgrade/upgradedashboard'));
const UpgardeDetails1MobileLazy = React.lazy(() => import('./mobile/SubscriptionAndBilling/NewPlanUpgrade/upgradeDetails'));
const TopupSuccessMobileLazy = React.lazy(() => import('./mobile/SubscriptionAndBilling/Payment/Payment_success'));
const TopupFailedMobileLazy = React.lazy(() => import('./mobile/SubscriptionAndBilling/Payment/payment_failed'));
const PayMentConfirmMobileLazy = React.lazy(() => import('./mobile/SubscriptionAndBilling/AddOns/paymentConfirm'));
const AddOnFlowsMobileLazy = React.lazy(() => import('./mobile/SubscriptionAndBilling/AddOns'));
const AddOnSuccessMobileLazy = React.lazy(() => import('./mobile/SubscriptionAndBilling/AddOns/Payment_success'));
const AddOnsFailedMobileLazy = React.lazy(() => import('./mobile/SubscriptionAndBilling/AddOns/payment_failed'));
const InvoiceManagementMobileLazy = React.lazy(() => import('./mobile/SubscriptionAndBilling/Invoice'));
const DeviceManagementMainMobileLazy = React.lazy(() => import('./mobile/DeviceManagement'));
const ViewDeviceMobileLazy = React.lazy(() => import('./mobile/DeviceManagement/viewDevice'));
const UpgradeSuccessDeviceMobileLazy = React.lazy(() => import('./mobile/DeviceManagement/successdevice'));
const PurchaseConfirmationMobileLazy = React.lazy(() => import('./mobile/DeviceManagement/confirmationSection'));
const PurchaseDeviceMobileLazy = React.lazy(() => import('./mobile/DeviceManagement/purchaseDevice'));
const PurchaseAddressMobileLazy = React.lazy(() => import('./mobile/DeviceManagement/purchaseAddress'));
const SetupDevicesMobileLazy = React.lazy(() => import('./mobile/DeviceManagement/purchaseDeviceTab/setDevice'));
const DevicePaymentFailedMobileLazy = React.lazy(() => import('./mobile/DeviceManagement/paymentfailed'));
const ReassignMobileLazy = React.lazy(() => import('./mobile/DeviceManagement/AssignedDevices/ressign'));
const ReassignDeviceMobileLazy = React.lazy(() => import('./mobile/DeviceManagement/AssignedDevices/reassigndevice'));
const ReplaceDeviceMobileLazy = React.lazy(() => import('./mobile/DeviceManagement/AssignedDevices/replacedevice'));
const PurchasePhoneMobileLazy = React.lazy(() => import('./mobile/DeviceManagement/AssignedDevices/purchasephone'));
const BringYourownPhoneMobileLazy = React.lazy(() => import('./mobile/DeviceManagement/AssignedDevices/bringyourownphone'));
const SwapPhoneMobileLazy = React.lazy(() => import('./mobile/DeviceManagement/AssignedDevices/swapphone'));
const MainAutoReceptionistMobileLazy = React.lazy(() => import('./mobile/AccountManagement/AutoReceptionist'));
const IVREditsMobileLazy = React.lazy(() => import('./mobile/AccountManagement/AutoReceptionist/ivredit'));
const HuntGroupMobileLazy = React.lazy(() => import('./mobile/AccountManagement/Huntgroup'));
const NewhuntGroupMobileLazy = React.lazy(() => import('./mobile/AccountManagement/Huntgroup/Newhuntgroup'));
const EditHuntGroupMobileLazy = React.lazy(() => import('./mobile/AccountManagement/Huntgroup/Edithuntgroup'));
const ProfileSettingsMobileLazy = React.lazy(() => import('./mobile/AccountManagement/ProfileSettings'));
const SaveGreetingsMobileLazy = React.lazy(() => import('./mobile/AccountManagement/SaveGreetings'));
const NumberInUserPageMobileLazy = React.lazy(() => import('./mobile/UserNumberAndDevice/numbers'));
const DeviceInUserPageMobileLazy = React.lazy(() => import('./mobile/UserNumberAndDevice/devices'));
const ConferenceInUserPageMobileLazy = React.lazy(() => import('./mobile/UserNumberAndDevice/conference'));
const MainForNumberAndDevicesMobileLazy = React.lazy(() => import('./mobile/UserNumberAndDevice'));
const LinkedAccountMobileLazy = React.lazy(() => import('./mobile/LinkedAccounts/insidepage'));
const UserAccountVoicemailMobileLazy = React.lazy(() => import('./mobile/AccountManagement/ProfileSettings/uservoiceMail'));
const ReportsMainMobileLazy = React.lazy(() => import('./mobile/Reports'));
const UserGeneralSettingsMobileLazy = React.lazy(() => import('./mobile/AccountManagement/ProfileSettings/usergeneralSettings'));

const Teams = React.lazy(() => import('./newpages/teamsintegration/teams'));
const ServiceTeams = React.lazy(() => import('./newpages/teamsintegration/serviceteams'));
const Teamsedit = React.lazy(() => import('./newpages/teamsintegration/editpages/edit'));
const Recentcallog = React.lazy(() => import('./newpages/teamsintegration/editpages/recentcallog'));

const PaymentLink = React.lazy(() => import('./desktop/PaymentLink/chatbot'))
const SuccessPayment = React.lazy(() =>import('./desktop/Upgrade/successPayment'))



function App() {
  const RouteBranch: any = Route;
  return (

    <BrowserRouter>
      {/* <BrowserView> */}
      <Routes>
        <Route
          path="/"
          element={
            <React.Fragment>
              <Suspense fallback={<Loader></Loader>}>
                <Home />
              </Suspense>
            </React.Fragment>
          }
        />

        <Route
          path="/forgotpassword"
          element={
            <React.Fragment>
              <Suspense fallback={<Loader></Loader>}>
                <ForgotPasswordLazy />
              </Suspense>
            </React.Fragment>
          }
        />
        <Route
          path="/reset-password"
          element={
            <React.Fragment>
              <Suspense fallback={<Loader></Loader>}>
                <ResetPasswordLazy />
              </Suspense>
            </React.Fragment>
          }
        />
        <Route
          path="*"
          element={
            <React.Fragment>
              <Suspense fallback={<Loader></Loader>}>
                <PageNotFoundBrowserLazy />
              </Suspense>
            </React.Fragment>
          }
        />

        <Route
          path="/unauthorized"
          element={
            <React.Fragment>
              <Suspense fallback={<Loader></Loader>}>
                <PageUnAuthorizedLazy />
              </Suspense>
            </React.Fragment>
          }
        />

        <Route
          path="/admin_onboarding/withpassword"
          element={
            <React.Fragment>
              <Suspense fallback={<Loader></Loader>}>
                <WithPasswordLazy />
              </Suspense>
            </React.Fragment>
          }
        />
        <Route
          path="/.well-known/assetlinks.json"
          element={
            <React.Fragment>
              <Suspense fallback={<Loader></Loader>}>
                <AssetLinkLazy />
              </Suspense>
            </React.Fragment>
          }
        />

        <Route
          path="/worktualcall_log"
          element={
            <React.Fragment>
              <Suspense fallback={<Loader></Loader>}>
                <WorktualCallLog />
              </Suspense>
            </React.Fragment>
          }
        />

        <Route
          path="/calllogin"
          element={
            <React.Fragment>
              <Suspense fallback={<Loader></Loader>}>
                <CallLogin />
              </Suspense>
            </React.Fragment>
          }
        />
        <Route
          path="/worktuallog"
          element={
            <React.Fragment>
              <Suspense fallback={<Loader></Loader>}>
                <WorktualCallLogs />
              </Suspense>
            </React.Fragment>
          }
        />

        <Route
          path="/paymentLink"
          element={
            <React.Fragment>
              <Suspense fallback={<Loader></Loader>}>
                <PaymentLink />
              </Suspense>
            </React.Fragment>
          }
        />

        <Route
          path="/successpayment"
          element={
            <React.Fragment>
              <Suspense fallback={<Loader></Loader>}>
                <SuccessPayment />
              </Suspense>
            </React.Fragment>
          }
        />

        {/* onboarding */}
        <Route
          path="/admin_onboarding"
          element={
            <React.Fragment>
              <Suspense fallback={<Loader></Loader>}>
                <AdminOnboardingLazy />
              </Suspense>
            </React.Fragment>
          }
        />

        <Route
          path="/audracareOnboarding"
          element={
            <React.Fragment>
              <Suspense fallback={<Loader></Loader>}>
                <AudraCareOnboarding />
              </Suspense>
            </React.Fragment>
          }
        />
        <Route
          path="/verify_email"
          element={
            <React.Fragment>
              <Suspense fallback={<Loader></Loader>}>
                <OnboardVerifyEmailLazy />
              </Suspense>
            </React.Fragment>
          }
        />
        <Route
          path="/admin_onboarding/mobile"
          element={
            <React.Fragment>
              <Suspense fallback={<Loader></Loader>}>
                <MobileOnboardingLazy />
              </Suspense>
            </React.Fragment>
          }
        />
        <Route
          path="/admin_onboarding/downloadapp"
          element={
            <React.Fragment>
              <Suspense fallback={<Loader></Loader>}>
                <DownloadAppLazy />
              </Suspense>
            </React.Fragment>
          }
        />
        <Route
          path="/user_onboarding"
          element={
            <React.Fragment>
              <Suspense fallback={<Loader></Loader>}>
                <UserOnboardingLazy />
              </Suspense>
            </React.Fragment>
          }
        />

        <RouteBranch element={<UserValidation />} >
          {/* <Route
              path="/dashboard"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <DashboardPageLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            /> */}
          <RouteBranch element={<SubOwnerValidation />}>


            <Route
              path="/overview"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <OverviewPageLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path="/paymentfailed"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <PaymentCommonFailedLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />

            {/* Account Management begins */}
            <Route
              path="/account-information"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <AccountInfoLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path="/account-information/edit"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <EditAccountInfoLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />

            {/* Account Settings begins */}
            <Route
              path="/accountmanagent/auto"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <MainAutoReceptionistLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />

            <Route
              path="/accountmanagent/ivr"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <IVREditsLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path="/huntgroup"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <HuntGroupLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path="/huntgroup/newhuntgroup"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <NewhuntGroupLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path="/huntgroup/edithuntgroup"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <EdithuntgroupLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path='/parklocation'
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <ParkLocationLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />

            <Route
              path='/parklocation/edit_park_location'
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <EditParkLocationLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />

            {/* Account Settings ends */}

            {/* Greeting Settings begins */}
            <Route
              path="/greetings"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <ProfileSettingsLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />



            <Route
              path='/numbers'
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <NumberInUserPageLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path='/devices'
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <DeviceInUserPageLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path='/conference'
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <ConferenceInUserPageLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />

            <Route
              path="/savegreetings"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <SaveGreetingsLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />

            <Route
              path='/recordings'
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <RecordingLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />



            <Route
              path="/activitylog"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <ActivitiesLogLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            {/* Account Management ends */}

            {/* User Management begins */}
            <Route
              path="/usermanagement"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <UserManagementLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path="/directrouting"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <Teams />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path="/directrouting/adminsetup"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <Initialsetup />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path="/directrouting/teams"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <ServiceTeams />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path="/directrouting/pbx"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <Servicespbx />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path="/userlist"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <UserList />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path="/directrouting/account"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <Accounts />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />

            <Route
              path="/teamsedit"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <Teamsedit />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path="/usersetting"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <UserSetting />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path="/usermanagement/adduser"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <AddUsersLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path="/usermanagement/editUser"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <EditUsersLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path="/importmapping"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <UserImportMappingLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path="/successupgradeplan"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <UpgradeSuccessPlanLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />

            <Route
              path="/failed"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <PaymentUpgradeFailedLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path='/usermanagement/upgradelicense'
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <Upgrade_LicenseLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path='/usermanagement/assignNumber'
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <UpgradeDid_LicenseLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path='/success'
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <LicenseSuccessLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />

            <Route
              path='/usermanagement/addon-user'
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <AddOnUser />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />

            <Route
              path='/role'
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <ProductRoleTableLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path='/role-permission'
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <RolePermissionLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path='/editproductfeature'
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <EditRolePermissionLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path='/custom-fields'
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <ManageCustomFieldLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />


            {/* User Management ends */}

            {/* Number Management begins */}
            <Route
              path="/number-management"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <NumberManagementLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path="/assignnewnumber"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <AssignedNewNumbersLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path="/assigncustomnumber"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <AddCustomNumber />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path="/numbermanagement/addnumber"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <AssignedNewNumbersLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path="/numbermanagement/confirmorder"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <ConfirmOrderLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />

            <Route
              path="/numbermanagement/paymentmethod"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <PaymentMethodLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path="/numbermanagement/payment"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <PaymentFormLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />

            <Route
              path="/numbermanagement/3ds_form"
              element={<ThreedSFormLazy />}
            />
            <Route
              path="/numbermanagement/3ds_form_check"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <ThreedSFormCheckLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path="/numbermanagement/saveorderconfirmation"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <SaveOrderConfirmationLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path="/numbermanagement/payment_failed"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <PaymentFaildLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path='/numbermanagement/addnumber/documentform'
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <DocumentFormLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />


            <Route
              path="/numbermanagement/paymentconfirmation"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <PaymentConfirmLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />

            <Route
              path="/port-in"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <PortInLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            {/* <Route
              path="/portnumber"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <PortNumberScreenLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            /> */}
            <Route
              path="/portnumber/congrats"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainFullLazy>
                      <CongratsLazy />
                    </LayoutMainFullLazy>
                  </Suspense>
                </React.Fragment>
              }
            />

            <Route
              path="/portnumber"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <InitialChecksLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path="/portnumber/step2"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <BasicinfoLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path="/portnumber/step3"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <SelectNumbersLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />

            <Route
              path="/portnumber/step4"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <NumberMappingLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path="/portnumber/step5"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <LetterAuthorizationLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />

            <Route
              path='/siptrunck'
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <SipTrunckLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path='/siptrunck/trunkinfo'
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <SipTrunkInfoLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path='/siptrunck/trunkinfoview'
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <SipTrunkInfoViewLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path='/siptrunck/didnumber'
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <SipDidNumberLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            {/* <Route
              path='/siptrunck/siprules'
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <SipRulesLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            /> */}

            <Route path='/siptrunck/siprules' element={<LayoutMain children={<SipRules />} />} />

            <Route
              path='/siptrunck/didnumberview'
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <SipDidNumberViewLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path='/siptrunck/rulesview'
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <SipRulesViewLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />

            <Route
              path='/conference-bridge'
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <ConferenceBridgeLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path='/conference-bridge-edit'
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <ConferenceBridgeEditLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />



            <Route
              path='/profile/security'
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <SecurityForUserLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />



            {/* Number Management ends */}

            {/* Device Management begins */}
            {/* <Route
              path="/device-management"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <DeviceManagementMainLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            /> */}

            <Route
              path="/device-management/viewdevice"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <ViewDeviceLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path="/device-management/success"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <UpgradeSuccessDeviceLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path="/device-management/address-device"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <PurchaseConfirmationLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path="/device-management/purchasedevice"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <PurchaseDeviceLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path="/device-management/purchase-address"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <PurchaseAddressLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path="/device-management/setupdevice"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <SetupDevicesLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path="/devicepaymentFailed"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <DevicePaymentFailedLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />

            <Route
              path="/device-management/reassign"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <ReassignLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />

            <Route
              path="/device-management/reassigndevice"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <ReassignDeviceLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />

            <Route
              path="/device-management/replacedevice"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <ReplaceDeviceLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path="/device-management/purchasephone"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <PurchasePhoneLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path="/device-management/bringyourownphone"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <BringYourownPhoneLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />

            <Route
              path="/device-management/swapphone"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <SwapPhoneLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            {/* Device Management ends */}

            {/* Subscription & billing begins */}
            <Route
              path="/subscriptionbill"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <Subscription_BillingLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path="/subscription/billing_contact"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <BillingContactsLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path="/subscriptionandbilling/payment"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <PaymentmethodsLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path="/subscriptionandbilling/payment/addcard"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <AddCardLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />

            <Route
              path="/subscriptionandbilling/payment/editcard"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <EditCardLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path='/subscriptionandbilling/payment/paymentCardList'
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <PaymentCardListLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />

            <Route
              path="/upgradedetails"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <UpgardeDetailsLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />

            <Route
              path="/downgradeshopify"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <ShopifydowngradePage />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />

            <Route
              path="/downgradeshopify/ShopifyPlanDetails"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <ShopifyPlanDetails />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />

            <Route
              path="/upgradesuccess"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <UpgradeSuccessLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path="/upgradedashboard/upgradedetails"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <UpgardeDetailsLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path="/upgradedashboard/ucassupgradedetails"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <UcassPlanDetailsLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path="/upgradedashboard"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <DashbordUpgradeLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />

            <Route
              path="/subscription-management/ccassplanupgradepage"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <CcassPlanUpgradeLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path='/subscription-management/chatbotupgradepage'
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <ChatBotUpgradePageLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path='/subscription-management/ucassplanupgradepage'
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <UcassPlanUpgradeLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path='/subscription-management/ccassplanupgradepage/ccasscardpage'
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <CcassPlanDetailsLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path='/subscription-management/chatbotupgradepage/chatbotplandetails'
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <ChatBotPlanDetailsLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path='/subscription-management/chatbotupgradepage/XaiaTwoFree'
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <XaiaTwoFreeLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path='/xaiatwopurchashed'
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <XaiaTwoSuccessPageLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path='/subscription-management'
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <UpgradeMainLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />

            <Route
              path='/subscription-management/newplanupgradepage'
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <NewUpgardeDetailsLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path='/subscription-management/newplanupgradepage/upgradedetails'
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <UpgardeDetails1Lazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />

            <Route
              path='/subscription-management/product_ccaas/upgradedetails'
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <NewProductCcaasUpgardeDetailsLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path='/subscription-management/product_ucaas/upgradedetails'
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <NewProductUcaasUpgardeDetailsLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />

            <Route
              path='/subscription-management/product_chatbot/upgradedetails'
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <NewProductChatbotUpgardeDetailsLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path='/subscription-management/product_crm/upgradedetails'
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <CrmPlanDetailsLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />


            <Route
              path='/topupsuccess'
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainFullLazy>
                      <TopupSuccessLazy />
                    </LayoutMainFullLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path='/topupfailed'
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <TopupFailedLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />

            <Route
              path='/purchasemain'
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <PurchaseFlowsMainLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path='/purchase'
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <PurchaseFlowsLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path='/addonsuccess'
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainFullLazy>
                      <AddonSuccessLazy />
                    </LayoutMainFullLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path='/addonfailed'
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <AddonFaildLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path='/invoice'
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <InvoiceManagementLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path='/invoice/:id'
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <InvoiceDetailsLazy />
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path='/invoicemanagement'
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <InvoiceManagementLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path='/invoicenew/:id'
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainFullLazy>
                      <InvoiceDetailsNewLazy />
                    </LayoutMainFullLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            {/* Subscription & billing ends */}

            {/* Security begins */}
            <Route
              path="/security"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <SecurityPolicyLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path="/createsecuritypolicy"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <CreateSecurityPolicyLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            {/* Security ends */}

            {/* Domains begins */}
            <Route
              path="/domain"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <DomainLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />

            <Route
              path="/domain/subdomainedit"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <SubdomainEditLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            {/* Domains ends */}

            {/* Reports begins */}
            {/* Reports ends */}

            {/* socialMedia begins */}
            <Route
              path='/integration'
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <SocialMediaIntegrationLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path='/whatsappIntergration'
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <WhatsappIntegrationLazy />
                    </LayoutMainLazy>
                  </Suspense>React.
                </React.Fragment>
              }
            />
            {/* socialMedia ends */}

            {/* Profile begins */}

            {/* Profile ends */}

            <Route
              path="/congrats"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainFullLazy>
                      <CongratsLazy />
                    </LayoutMainFullLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path="/selected-products"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <CartItemsListsLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />

            <Route
              path="/payment-confirm"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <PayMentConfirmLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path="/step2"
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <Step2Lazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />

            <Route
              path='/purchase/numberpurchaseaddon'
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <PurchaseNumberAddonLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
            <Route
              path='/numbermanagement/addnewno'
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <AddNewNumberLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />


            <Route
              path='/reports'
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <ReportsMainLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />

            <Route
              path='/shopifyPaySuccess'
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <ShopifyPlanUpgradeSuccessLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />

            {/* only for CCaas user */}
            <RouteBranch element={<CcaasValidation />} >

            </RouteBranch>

            {/* only for UCaas user */}
            <RouteBranch element={<UcaasValidation />} >
              <Route
                path="/huntProfile"
                element={
                  <React.Fragment>
                    <Suspense fallback={<Loader></Loader>}>
                      <LayoutMainLazy>
                        <HuntProfileLazy />
                      </LayoutMainLazy>
                    </Suspense>
                  </React.Fragment>
                }
              />

              <Route
                path="/callqueue"
                element={
                  <React.Fragment>
                    <Suspense fallback={<Loader></Loader>}>
                      <LayoutMainLazy>
                        <CallQueueLazy />
                      </LayoutMainLazy>
                    </Suspense>
                  </React.Fragment>
                }
              />
              <Route
                path="/callqueueprofile"
                element={
                  <React.Fragment>
                    <Suspense fallback={<Loader></Loader>}>
                      <LayoutMainLazy>
                        <CallQueueProfileLazy />
                      </LayoutMainLazy>
                    </Suspense>
                  </React.Fragment>
                }
              />
              <Route
                path="/addcallqueue"
                element={
                  <React.Fragment>
                    <Suspense fallback={<Loader></Loader>}>
                      <LayoutMainLazy>
                        <AddCallQueueLazy />
                      </LayoutMainLazy>
                    </Suspense>
                  </React.Fragment>
                }
              />
              <Route
                path='/editcallqueue/:id'
                element={
                  <React.Fragment>
                    <Suspense fallback={<Loader></Loader>}>
                      <LayoutMainLazy>
                        <EditCallQueueLazy />
                      </LayoutMainLazy>
                    </Suspense>
                  </React.Fragment>
                }
              />
              <Route
                path="/huntgroup"
                element={
                  <React.Fragment>
                    <Suspense fallback={<Loader></Loader>}>
                      <LayoutMainLazy>
                        <HuntGroup />
                      </LayoutMainLazy>
                    </Suspense>
                  </React.Fragment>
                }
              />

              <Route
                path="/huntgroup/newhuntgroup"
                element={
                  <React.Fragment>
                    <Suspense fallback={<Loader></Loader>}>
                      <LayoutMainLazy>
                        <NewhuntGroupLazy />
                      </LayoutMainLazy>
                    </Suspense>
                  </React.Fragment>
                }
              />
              <Route
                path="/huntgroup/edithuntgroup"
                element={
                  <React.Fragment>
                    <Suspense fallback={<Loader></Loader>}>
                      <LayoutMainLazy>
                        <EdithuntgroupLazy />
                      </LayoutMainLazy>
                    </Suspense>
                  </React.Fragment>
                }
              />
              <Route
                path="/callqueue"
                element={
                  <React.Fragment>
                    <Suspense fallback={<Loader></Loader>}>
                      <LayoutMainLazy>
                        <CallQueueLazy />
                      </LayoutMainLazy>
                    </Suspense>
                  </React.Fragment>
                }
              />
              <Route
                path="/callqueueprofile"
                element={
                  <React.Fragment>
                    <Suspense fallback={<Loader></Loader>}>
                      <LayoutMainLazy>
                        <CallQueueProfileLazy />
                      </LayoutMainLazy>
                    </Suspense>
                  </React.Fragment>
                }
              />
              <Route
                path="/addcallqueue"
                element={
                  <React.Fragment>
                    <Suspense fallback={<Loader></Loader>}>
                      <LayoutMainLazy>
                        <AddCallQueueLazy />
                      </LayoutMainLazy>
                    </Suspense>
                  </React.Fragment>
                }
              />
              {/* <Route
                path="/reports"
                element={
                  <React.Fragment>
                    <Suspense fallback={<Loader></Loader>}>
                      <LayoutMainLazy>
                        <ReportsMainLazy />
                      </LayoutMainLazy>
                    </Suspense>
                  </React.Fragment>
                }
              /> */}
              <Route
                path="/worktualreports"
                element={
                  <React.Fragment>
                    <Suspense fallback={<Loader></Loader>}>
                      <LayoutMainLazy>
                        <WorktualReportsLazy />
                      </LayoutMainLazy>
                    </Suspense>
                  </React.Fragment>
                }
              />
              <Route
                path="/viewreports"
                element={
                  <React.Fragment>
                    <Suspense fallback={<Loader></Loader>}>
                      <LayoutMainLazy>
                        <ViewReportsLazy />
                      </LayoutMainLazy>
                    </Suspense>
                  </React.Fragment>
                }
              />

              <Route
                path="/call_log"
                element={
                  <React.Fragment>
                    <Suspense fallback={<Loader></Loader>}>
                      <LayoutMainLazy>
                        <AdminCallLog />
                      </LayoutMainLazy>
                    </Suspense>
                  </React.Fragment>
                }
              />


              <Route
                path="/recentcalllog"
                element={
                  <React.Fragment>
                    <Suspense fallback={<Loader></Loader>}>
                      <LayoutMainLazy>
                        <Recentcallog />
                      </LayoutMainLazy>
                    </Suspense>
                  </React.Fragment>
                }
              />



            </RouteBranch>
            <Route
              path='/otpverify'
              element={
                <React.Fragment>
                  <Suspense fallback={<Loader></Loader>}>
                    <LayoutMainLazy>
                      <VerifyEmailLazy />
                    </LayoutMainLazy>
                  </Suspense>
                </React.Fragment>
              }
            />
          </RouteBranch>

          {/* only for user */}





          {/* <RouteBranch element={<UserpValidation />} >
              <Route path='/userprofile' element={<LayoutMain children={<UserDetails />} />} />
              <Route path='/userprofile/edit' element={<LayoutMain children={<UserProfileDetailsEdit />} />} />
            </RouteBranch> */}



          <Route
            path="/profile"
            element={
              <React.Fragment>
                <Suspense fallback={<Loader></Loader>}>
                  <LayoutMainLazy>
                    <ProfileDetailsLazy />
                  </LayoutMainLazy>
                </Suspense>
              </React.Fragment>
            }
          />
          <Route
            path="/profile/edit"
            element={
              <React.Fragment>
                <Suspense fallback={<Loader></Loader>}>
                  <LayoutMainLazy>
                    <ProfileDetailsEditLazy />
                  </LayoutMainLazy>
                </Suspense>
              </React.Fragment>
            }
          />
          <Route
            path='/numbersanddevices'
            element={
              <React.Fragment>
                <Suspense fallback={<Loader></Loader>}>
                  <LayoutMainLazy>
                    <MainForNumberAndDevicesLazy />
                  </LayoutMainLazy>
                </Suspense>
              </React.Fragment>
            }
          />

          <Route
            path='/linkedaccounts'
            element={
              <React.Fragment>
                <Suspense fallback={<Loader></Loader>}>
                  <LayoutMainLazy>
                    <LinkedAccountLazy />
                  </LayoutMainLazy>
                </Suspense>
              </React.Fragment>
            }
          />

          <Route
            path='/callhandling-and-forwarding'
            element={
              <React.Fragment>
                <Suspense fallback={<Loader></Loader>}>
                  <LayoutMainLazy>
                    <UserGeneralSettingsLazy />
                  </LayoutMainLazy>
                </Suspense>
              </React.Fragment>
            }
          />

          <Route
            path='/uservoicemail'
            element={
              <React.Fragment>
                <Suspense fallback={<Loader></Loader>}>
                  <LayoutMainLazy>
                    <UserAccountVoicemailLazy />
                  </LayoutMainLazy>
                </Suspense>
              </React.Fragment>
            }
          />

          <Route
            path='/usercalllogs'
            element={
              <React.Fragment>
                <Suspense fallback={<Loader></Loader>}>
                  <LayoutMainLazy>
                    <UserCallLog />
                  </LayoutMainLazy>
                </Suspense>
              </React.Fragment>
            }
          />

        </RouteBranch>

      </Routes>
      {/* </BrowserView> */}
    </BrowserRouter>
  );
}

export default App;